import UsersTab from "../components/organisms/UsersTab";
import { useUsersUrlQuery } from "../api/user/users.queries";
import { LoadingBlurDiv } from "@shared/components";

const UsersPage = () => {
  const { query, setFilters, resetFilters, currentFilters } =
    useUsersUrlQuery();

  return (
    <LoadingBlurDiv isLoading={query.isFetching}>
      <UsersTab
        users={query.data?.data || []}
        paginatedMeta={query.data?.meta}
        isLoading={query.isFetching}
        onFilter={setFilters}
        onClearFilter={resetFilters}
        initialFilters={currentFilters}
      />
    </LoadingBlurDiv>
  );
};

export default UsersPage;
